import type { ModelDefinition } from './api';

export const getModelIconName = (modelName: string): string => {
  const key = (modelName || '').trim().toLowerCase();
  if (key.includes('license_plate') || key.includes('plate') || key === 'lpd') return 'plates.svg';
  if (key === 'fire_and_smoke_detector' || key === 'fire') return 'fire-smoke.svg';
  if (key === 'smoke') return 'smoke.svg';
  if (key === 'people' || key === 'person' || key === 'absence' || key === 'absence_end' || key.includes('staff')) return 'people.svg';
  if (key.includes('smoking') || key === 'cigarette') return 'kyrenie.svg';
  if (key.includes('garbage_truck')) return 'mysor.svg';
  if (key.includes('tractor')) return 'tractor.svg';
  if (
    key.includes('multiple_rtsp') ||
    key.includes('vehicle') ||
    key.includes('car') ||
    ['bus', 'truck', 'police', 'ambulance', 'firetruck'].includes(key)
  ) return 'car.svg';
  return 'lock.svg';
};

export const getCategoryIconName = (categoryId: string, models: ModelDefinition[]): string => {
  const key = (categoryId || '').trim().toLowerCase();
  if (['vehicles', 'vehicle', 'transport', 'cars'].includes(key)) return 'car.svg';
  if (['people', 'person', 'persons', 'staff'].includes(key)) return 'people.svg';
  if (['safety', 'security', 'fire'].includes(key)) return 'fire-smoke.svg';
  const firstModel = models.find((model) => model.category === categoryId);
  return getModelIconName(firstModel?.name || categoryId);
};

export const modelIconUrl = (iconName: string): string =>
  iconName === 'plates.svg'
    ? `${process.env.PUBLIC_URL}/icons/svg_icon/plates.svg`
    : `${process.env.PUBLIC_URL}/icons/modals/${iconName}`;
